import React from "react"
import { connect } from "react-redux";
import { constants } from "../../Constants";
import "./sessionDetail.css"
import Header from "../../components/Header";
import Footer from "../../components/Footer/footer";
import { appointmentActions } from "../../store/actions";
import Loading from "../../components/Loading/Loading";
import moment from "moment";
import SessionPatientDetail from "../../components/SessionAndPatientDetail/SessionPatientDetail";

class SessionDetails extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentAppointment: null
        }

    }

    getInitials(name) {
        const parts = name.split(" ")
        const initials = parts[0].charAt(0).toUpperCase() + (parts.length > 1 ? parts[1].charAt(0).toUpperCase() : '');

        return initials
    }

    componentWillMount() {
        const project_id = localStorage.getItem("project_id");
        this.props.getAppointments(project_id);
    }
    componentWillReceiveProps(nextProps) {
        let currentID = window.location.href.split("appointment-details/")[1]
        let currAppointment = {}
        nextProps.appointments && nextProps.appointments.forEach(appointment => {
            if (appointment.id === currentID) currAppointment = appointment
        })
        this.setState({ currentAppointment: currAppointment })
    }
    render() {
        let user = JSON.parse(localStorage.getItem("user"))
        let userRole = user.role
        let totalSessionCaps;
        let consumedSessionCaps
        let isSessionCapAllowed
        let appDetail = {}

        if (this.state.currentAppointment) {
            
            appDetail = this.state.currentAppointment
            if (appDetail.patient) {
                isSessionCapAllowed = appDetail.patient.project.is_session_cap_allowed                
                totalSessionCaps = appDetail.patient.total_session_cap
                consumedSessionCaps = appDetail.patient.consumed_session_cap
            }
        }

        return (
            <div className="sh-layout">
                <Header />
                {this.state.currentAppointment ?
                    <SessionPatientDetail
                        detailHeading={constants.APPOINTMENT_DETAILS_TXT.toUpperCase()}
                        profileImage={userRole === 1 ? appDetail.counsellor_image : ''}
                        initials={userRole === 1 && appDetail.counsellor_name ? this.getInitials(appDetail.counsellor_name) : appDetail.patient_name ? this.getInitials(appDetail.patient_name) : ''}
                        userName={userRole === 1 ? appDetail.counsellor_name : appDetail.patient_name}
                        specialities={userRole === 1 && appDetail.counsellor && appDetail.counsellor.area_of_expertise}
                        sessionDate={moment(appDetail.date_time).format("dddd DD MMMM")}
                        sessionTime={moment(appDetail.date_time).format('hh:mm a')}
                        serviceType={appDetail.service_type && appDetail.service_type.name}
                        totalSessionCaps={totalSessionCaps}
                        consumedSessionCaps={consumedSessionCaps}
                        isSessionCapAllowed={isSessionCapAllowed}
                        showServiceType={this.props.whitelabel && this.props.whitelabel[0].name.toLowerCase() === "cwp" ? false : true}
                    />
                    : <Loading />}
                <Footer />
            </div>
        )
    }
}


const mapStateToProps = (state) => {
    const { appointments } = state.appointments;
    const { user } = state.auth
    const {whitelabel} = state.whitelabel
    return {
        appointments,
        user,
        whitelabel
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        getAppointments: (id) => {
            dispatch(appointmentActions.getAppointments(id));
        },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(SessionDetails)


// WEBPACK FOOTER //
// ./src/screens/SessionDetails/index.js